<template>
  <div class="d-flex">
    <b-container class="m-auto">
      <b-row align-h="center" align-v="center">
        <b-col cols="auto">
        <font-awesome-layers class="mb-5 mr-5">
          <font-awesome-icon icon="hand-paper" size="3x" class="ml-3"/>
          <font-awesome-icon icon="ban" :style="{ color: 'red' }" size="5x" />
        </font-awesome-layers>
        </b-col>
      </b-row>

      <b-row align-h="center" align-v="center">
        <h6 v-if="isMobile">{{$t('message.pathNotActive')}}</h6>
        <h3 v-else>{{$t('message.pathNotActive')}}</h3>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'PathNotActive',
  mounted () {
    this.checkWindowWidth()
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    return {
      isMobile: false
    }
  },
  methods: {
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    }
  }
}
</script>
